"use strict";

var _getOutstandingOnboardingActionsNum_Query;
import "core-js/modules/es.promise.js";
import { getEnvironment } from '@autoguru/relay';
import { fetchQuery, graphql } from 'relay-runtime';
export const getOutstandingOnboardingActionsNum = async ({
  supplierSlug
}) => {
  if (!supplierSlug) {
    return 0;
  }
  const {
    supplier
  } = await fetchQuery(getEnvironment(), _getOutstandingOnboardingActionsNum_Query !== void 0 ? _getOutstandingOnboardingActionsNum_Query : _getOutstandingOnboardingActionsNum_Query = require("../../relay/__generated__/getOutstandingOnboardingActionsNum_Query.graphql"), {
    supplierSlug
  }, {
    fetchPolicy: 'store-or-network'
  }
  // @ts-ignore
  ).toPromise();
  return supplier.configurationWarnings.length;
};